export const createTabStateManager = (storageKey, defaultTab, availableTabs = []) => {
  return {
    setActiveTab(tab) {
      if (availableTabs.length === 0 || availableTabs.includes(tab)) {
        localStorage.setItem(storageKey, tab);
      }
    },
    getActiveTab() {
      const saved = localStorage.getItem(storageKey);
      if (saved && (availableTabs.length === 0 || availableTabs.includes(saved))) {
        return saved;
      }
      return defaultTab;
    },
    clear() {
      localStorage.removeItem(storageKey);
    },
  };
};
